<template>
        <!--派样活动配置-->
        <div>
            <el-form  :inline="true" >
                <el-form-item>
                    <el-select class="m-1" v-model="kioskNo" placeholder="选择售货机" default-first-option  @change="getData()">
                        <el-option v-for="item in kioskNoList" :label="item.deviceName" :value="item.machine_id"  ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="productName" placeholder="商品SKU"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary"  @click="getData()" icon="search" :loading="loading">查询</el-button>
                    <el-button type="primary" @click="resetForm()">重置</el-button>



                </el-form-item>
            </el-form>



                <!-- 单选-->
            <el-table v-if="!is_checkbox" ref="multipleTable"  :data="tableData" tooltip-effect="dark"
                      style="width: 100%"
                      highlight-current-row
                      @current-change="handleSelectionChange">
              <!--  <el-table-column type="index" width="50"></el-table-column>-->
                <el-table-column align="center" prop="Image" label="商品图片">
                    <template slot-scope="scope">
                        <img :src="scope.row.Image" class="avatar" style="height: 50px;">
                    </template>
                </el-table-column>
                <el-table-column prop="productName" label="商品名称"></el-table-column>
               <!-- <el-table-column prop="price" label="商品价格"></el-table-column>-->
                <el-table-column prop="kioskNo" label="机器编号"></el-table-column>
                <el-table-column prop="categoriesName" label="品类"></el-table-column>
                <el-table-column prop="ppwPrice" label="线上价格">
                    <template slot-scope="scope">

                        <span v-if="scope.row.ppwPrice != scope.row.price" style="color:red">{{ scope.row.ppwPrice }}</span>
                        <span v-else>{{ scope.row.ppwPrice }}</span>
                    </template>
                </el-table-column>

                <el-table-column prop="num" label="库存"></el-table-column>

               <!-- <el-table-column  label="操作" width="230px">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="affirProduct(scope.row)" >添加</el-button>
                    </template>
                </el-table-column>-->
            </el-table>
                <!-- 多选-->
                <el-table v-if="is_checkbox" ref="multipleTable"  :data="tableData" tooltip-effect="dark"
                          style="width: 100%"
                          @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column
                            type="index"
                            width="50">
                    </el-table-column>
                    <el-table-column align="center" prop="Image" label="商品图片">
                        <template slot-scope="scope">
                            <img :src="scope.row.Image" class="avatar" style="height: 50px;">
                        </template>
                    </el-table-column>
                    <el-table-column prop="productName" label="商品名称"></el-table-column>
                    <el-table-column prop="price" label="商品价格"></el-table-column>
                    <el-table-column prop="kioskNo" label="机器编号"></el-table-column>
                    <el-table-column prop="categoriesName" label="品类"></el-table-column>
                    <el-table-column prop="ppwPrice" label="线上价格">
                        <template slot-scope="scope">
                            <span v-if="scope.row.ppwPrice != scope.row.price" style="color:red">{{ scope.row.ppwPrice }}</span>
                            <span v-else>{{ scope.row.ppwPrice }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="num" label="库存"></el-table-column>

                </el-table>
            <div class="block">

                <el-pagination
                        @current-change="handleCurrentChange"
                        @size-chahange="handleSizeChange"
                        :current-page="currentpage"
                        :page-count="pagesCount"
                        :page-sizes="pagesizes"
                        :page-size="pagesize"
                        :total="pagesCount"
                        layout=" total, prev, pager, next, jumper"
                >
                </el-pagination>
            </div>

        <br>
            <div style="text-align: center">
                <el-button type="primary"  :disabled="disabled"  @click="addProduct()" >确认添加</el-button>
                <el-button type="primary"  @click="CloseProduct()" >取消</el-button>
            </div>


        </div>
</template>

<script>
    import ElForm from "../../../../node_modules/element-ui/packages/form/src/form.vue";
    import ElFormItem from "../../../../node_modules/element-ui/packages/form/src/form-item.vue";

    export default {
        components: {
            ElFormItem,
            ElForm},
        name: "ProductPutaWay",
        props:
            [
                'kioskNoList','is_checkbox'
            ],

        data() {
            return  {
                    activeName: 'second',
                    kioskNo: '',
                    productName: '',
                    productPushName: '',
                    //页眉设置参数
                    currentpage: 1,//当前页数默认是1
                    pagesCount: 0, //总数默认0
                    pagesizes: [10, 20, 30],//条数列
                    pagesize: 5,//行数
                    activeNum: 0, //默认起始行数
                    endNum: 10,//默认结束行数
                    tableData: [], // 分页组件传回的分页后数据
                    pushData: [], // 分页组件传回的分页后数据
                    /*弹窗选择*/
                    loading: false,
                    isorno: false,
                    synloading: false,
                    multipleSelection: [],
                disabled:true,
                    url: this.productURL + "/vueFeign/getProductPutaway", // 分页查询请

            }

        },
        created(){
           // debugger
            if(this.kioskNoList.length>0){
                this.kioskNo=this.kioskNoList[0].machine_id;
                this.getData()
            }

        },
        watch:{
           /* kioskNoList: {
                handler: function (val, oldVal) {
                    debugger
                    if(this.kioskNoList.length>0){
                        this.kioskNo=this.kioskNoList[0].kioskNo;

                    }
                },
                deep: true
            }*/

        },
        methods: {
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.pagesize = val
                this.activeNum = (val * this.currentpage) - val;
                this.endNum = (val * this.currentpage)
                this.getData();
                //数目变更
            },
            handleCurrentChange(val) {
                this.currentpage = val;
                this.activeNum = (this.pagesize * val) - this.pagesize
                this.endNum = (this.pagesize * val)
                this.getData();
            },
            resetForm() {
                this.productName = '';
                this.kioskNo="";
            },
            handleSelectionChange(val) {
                if(val.length==0){
                    this.disabled=true;
                }else{
                    this.disabled=false;
                }
                this.multipleSelection= val;

            },
            addProduct(){
               /* if(this.multipleSelection.length>0){*/

                    this.$emit('handle-selection-change',this.multipleSelection)

                this.CloseProduct();
                //this.$message({showClose: true, message: "操作成功", type: 'success'});
               /* }else{
                    this.$message({
                        showClose: true,
                        message: '必须要选择一个商品',
                        type: 'error'
                    });
                }*/
            },
            CloseProduct(){
                this.multipleSelection=[];
                this.$emit('close-product',this.multipleSelection)
            },
            affirProduct(row){
                this.$emit('handle-selection-change',row)
                this.CloseProduct();
            },
            getData() {
                //数据请求
                this.loading = true
                var params = {
                    active: this.activeNum,
                    len: this.pagesize,
                    kioskNo: this.kioskNo,
                    tenantId: this.getcookie('storeId'),
                    productName:this.productName
                };
                //异步请求
                this.$http.post(this.url, params)
                    .then(response => {
                        if (response.status === 200) {
                            if (response.body.Code == '200') {
                                this.tableData = response.body.Data.data
                                this.pagesCount=response.body.Data.count
                                this.loading = false;

                            } else if (response.body.code == '500') {
                                this.$message({showClose: true, message: response.body.msg, type: 'error'});
                            }
                        }
                    }, function (response) {
                        this.loading = false;
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ProductPutaWay.vue?f4e48760